import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { SelfCheckoutStreamStore } from '@formunauts/self-checkout/data-access';
import * as O from 'effect/Option';
/**
 * @returns
 * Guard function that returns true if the self checkout form step
 * "confirm" is available.
 */
export function hasSelfCheckoutForm() {
  return (childRoute: ActivatedRouteSnapshot): boolean | UrlTree => {
    const service = inject(SelfCheckoutStreamStore);
    const hash = service.hash();

    const form = service.retriveCheckoutFormStorage(hash);

    // If we already got the form, we can proceed
    if (O.isSome(form)) {
      return true;
    }

    // Navigate to authentication form
    const router = inject(Router);
    return router.createUrlTree(['verify', hash]);
  };
}
